import React, { useContext } from 'react';
import { Button, Grid, Typography } from '@mui/material';
import firebase from 'firebase/app';
import { Link } from 'react-router-dom';
import { UIContext } from '../../Unknown/UIContext';
import logo from '../assets/logo.svg';
import SignUpForm from '../SignUpForm';
import 'firebase/auth';
import bgImage from '../assets/login-bg.svg';

export interface SignUpTypes {
  name: string;
  email: string;
  password: string;
}

const SignUpScreen: React.FC = () => {
  const { setAlert } = useContext(UIContext);
  async function handleSubmitChange(
    values: SignUpTypes,
    setSubmitting: (isSubmitting: boolean) => void,
  ) {
    setSubmitting(true);
    firebase
      .auth()
      .createUserWithEmailAndPassword(values.email, values.password)
      .then((userCredential) => {
        setAlert({
          show: true,
          severity: 'success',
          message: 'Welcome on board 🚀',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center',
          },
        });
        if (userCredential.user !== null) {
          userCredential.user.updateProfile({
            displayName: values.name,
          });
        }
      })
      .catch((error) => {
        const errorMessage =
          error instanceof Error ? error.message : 'Something went wrong';
        setAlert({
          show: true,
          severity: 'error',
          message: errorMessage,
        });
      })
      .finally(() => {
        setSubmitting(false);
      });
  }
  return (
    <>
      <Grid container height="100vh">
        <Grid
          item
          xs={6}
          sx={{
            background: `url(${bgImage}) no-repeat center`,
            backgroundSize: 'cover',
            boxSizing: 'border-box',
          }}
        />
        <Grid sx={{ textAlign: 'center', paddingTop: '10%' }} item xs={6}>
          <img src={logo} alt="logo" />
          <Typography mb={10} variant="h2">
            Register
          </Typography>
          <SignUpForm handleSubmitChange={handleSubmitChange} />
          <Typography pt={4} variant="h5">
            Already have account?
          </Typography>
          <Button
            sx={{ marginTop: '10px', fontSize: '16px' }}
            component={Link}
            to="/login"
            color="primary"
          >
            Login
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default SignUpScreen;
